import { getCommentHost,sohuHost,focusHost,focusUcenterHost } from '@/config/urlConfig'
import { createAxiosByInterceptors } from './axios'

const CommentInstance = createAxiosByInterceptors({
    baseURL: getCommentHost(),
})

const SohuInstance = createAxiosByInterceptors({
    baseURL: sohuHost(),
})

const FocusInstance = createAxiosByInterceptors({
    baseURL: focusHost(),
})

const FocusUcenterInstance = createAxiosByInterceptors({
    baseURL: focusUcenterHost(),
})


// 获取评论基础信息
export const initComment = function (data) {
    const params =  {
        source_id: data.sourceId,
            page_no: 1,
            page_size: 1,
            reply_count: 1,
            type: 0
    }
    return CommentInstance.get('/api/comments/maincomments/', {params})
}

// 获取文章内容
export const getArticleContent = function () {
    const spmA = window?.sohuSpm?.getCodes()?.a
    if(spmA.includes('jd')) return FocusInstance.get(`/api/article_data${cfgs.stage}`) // 焦点
    else return SohuInstance.get(`/api/article_data${cfgs.stage}`)
}


// 获取焦点用户信息
export const getFocusUserInfo = function () {
    const uri = '/passport/getUserInfo'
    return FocusUcenterInstance.get(uri)
}

/**
 * @description 上传图片接口
 * @param {FormData} formData 
 * @returns 
 */
export const uploadImg = async (formData) => {
    try {
        const data = await CommentInstance.post("/upload/image", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
            timeout: 30000, // 上传图片超时,与测试&后端协调,设置为30s
        })
        return data
    } catch (error) {
        throw new Error("上传图片接口调用失败," + error.message)
    }
}
